import { unescape } from 'lodash';
import { v4 as uuid } from 'uuid';
import { HawksearchGlobal } from '@models';

declare let Hawksearch: HawksearchGlobal;

export abstract class BaseService {
    protected abstract baseUrl: string;

    protected fieldMappings = {
        imageUrl: Hawksearch.config.fieldMappings?.imageUrl || 'image',
        price: Hawksearch.config.fieldMappings?.price || 'price',
        salePrice: Hawksearch.config.fieldMappings?.salePrice || 'saleprice',
        title: Hawksearch.config.fieldMappings?.title || 'itemname',
        type: Hawksearch.config.fieldMappings?.type || 'type',
        url: Hawksearch.config.fieldMappings?.url || 'url'
    };

    protected queryStringParams = {
        disableSpellcheck: Hawksearch.config.queryStringMappings?.disableSpellcheck || 'disableSpellcheck',
        facet: Hawksearch.config.queryStringMappings?.facet || 'facet',
        page: Hawksearch.config.queryStringMappings?.page || 'page',
        pageSize: Hawksearch.config.queryStringMappings?.pageSize || 'pageSize',
        query: Hawksearch.config.queryStringMappings?.query || 'query',
        searchWithin: Hawksearch.config.queryStringMappings?.searchWithin || 'searchWithin',
        sort: Hawksearch.config.queryStringMappings?.sort || 'sort'
    };

    protected async httpPost<T>(relativeUrl: string, body?: any): Promise<T> {
        const url = this.baseUrl + relativeUrl;
        const headers = this.getHeaders();

        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });

        const contentType = response.headers.get('content-type');

        if (contentType?.startsWith('application/json')) {
            return response.json();
        } else {
            return undefined as unknown as T;
        }
    }

    protected stripHtml(input: string): string {
        let output = input.replace(/<[^>]+>/g, '');

        output = unescape(output);
        output = decodeURIComponent(output);

        return output;
    }

    private getHeaders(): Headers {
        const headers = new Headers();

        headers.set('Content-Type', 'application/json');
        headers.set('X-Requested-With', 'XMLHttpRequest');

        return headers;
    }

    protected getVisitorId(): string {
        const key = 'VisitorId';
        let value = localStorage.getItem(key);

        if (!value) {
            value = this.generateGuid();

            localStorage.setItem(key, value);
        }

        return value;
    }

    protected getVisitId(): string {
        const key = 'VisitId';
        let value = sessionStorage.getItem(key);

        if (!value) {
            value = this.generateGuid();

            sessionStorage.setItem(key, value);
        }

        return value;
    }

    protected generateGuid(): string {
        return uuid();
    }
}
